import { render, staticRenderFns } from "./ContractPercentageFluctuation.vue?vue&type=template&id=3c620734"
import script from "./ContractPercentageFluctuation.vue?vue&type=script&lang=js"
export * from "./ContractPercentageFluctuation.vue?vue&type=script&lang=js"
import style0 from "./ContractPercentageFluctuation.vue?vue&type=style&index=0&id=3c620734&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports